import React from 'react';
import { Modal, Field } from './ui';

// Desktop add/edit form modal for the field-driven CRUD folders (functions /
// guests): two-column grid, `half` fields share a row. Reads the useCrudList `vm`.
export default function CrudFormModalDesktop({ vm, title }) {
  const { editing, values, fields, saving, setField, save, closeForm, clearForm, isDirty } = vm;
  if (!vm.open) return null;
  return (
    <Modal
      title={`${editing ? 'Edit' : 'Add'} ${title}`}
      onClose={closeForm}
      isDirty={isDirty}
      onClear={clearForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      <div className="form-grid">
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: f.half ? 'auto' : '1 / -1' }}>
            <Field
              label={f.label} type={f.type || 'text'} value={values[f.key]}
              options={f.options} required={f.required}
              onChange={(v) => setField(f, v)}
            />
          </div>
        ))}
      </div>
    </Modal>
  );
}
